import { ITextCard } from '@/utils/interfaces/components';
import { storyblokEditable } from '@storyblok/react';
import { WysiwygContainer } from './Layout/WysiwygContainer';
import { render } from 'storyblok-rich-text-react-renderer';

interface IProps {
  blok: ITextCard;
}

export const TextCard: React.FC<IProps> = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)} className="md:p-10 p-7 bg-white border-[1px] border-green rounded-lg shadow-sm text-left">
      <h3 style={{ background: 'linear-gradient(90deg, #22B573 0%, #1BD0BC 100%)' }} className="text-sm px-3 rounded inline-block py-2 text-white font-semibold mb-2">{blok.label}</h3>
      <p className=" text-4xl my-6 font-bold text-green-dark">{blok.heading}</p>

      {blok.body?.map((nested, index) => (
        <WysiwygContainer classname="lg:!my-0 govt-wysiwig" key={nested._uid || index} narrow={true}>
          <div className="wyswiyg-content">
            {nested.content ? render(nested.content) : null}
          </div>
        </WysiwygContainer>
      ))}
    </div>
  );
};